<script>
import { Line, mixins } from 'vue-chartjs'
const { reactiveProp } = mixins

export default {
  extends: Line,
  mixins: [reactiveProp],
  props: {
    chartTitle: String,
    chartData: Object,
    options: Object,

    xAxisLabel: String,
    xAxisTicksMinRotation: Number,
    xAxisTicksMaxRotation: Number,
    xAxisTimeUnit: String,

    yAxisLabel: String,
    yAxisPrecision: Number,

    hideLegend: Boolean,
  },

  mounted() {
    let options = Object.assign(
      {},
      this.options || {},
      {
        responsive: true,
        title: {
          display: !!this.chartTitle,
          text: this.chartTitle,
        },
        legend: {
          display: !this.hideLegend,
        },
        onClick: ($event, elements) => this.onClick($event, elements),
        scales: {
          xAxes: [{ ticks: {}, scaleLabel: { display: this.xAxisLabel, labelString: this.xAxisLabel } }],
          yAxes: [{ ticks: { min: 0 }, scaleLabel: { display: this.yAxisLabel, labelString: this.yAxisLabel } }],
        }
      },
    )

    if (this.xAxisTicksMinRotation) {
      options.scales.xAxes[0].ticks.minRotation = this.xAxisTicksMinRotation;
    }
    if (this.xAxisTicksMaxRotation) {
      options.scales.xAxes[0].ticks.maxRotation = this.xAxisTicksMaxRotation;
    }
    if (this.xAxisTimeUnit) {
      options.scales.xAxes[0].type = 'time';
      options.scales.xAxes[0].time = { unit: this.xAxisTimeUnit };
    }

    if (this.yAxisPrecision || this.yAxisPrecision === 0) {
      options.scales.yAxes[0].ticks.precision = this.yAxisPrecision;
    }

    this.renderChart(this.chartData, options);
  },

  methods: {
    onClick($event, elements) {
      if (!elements || elements.length === 0) {
        return;
      }

      let firstElement = elements[0];
      this.$emit('click', { dataSetIndex: firstElement._datasetIndex, elementIndex: firstElement._index })
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/charts/components/LineChart.vue